import moment from 'moment';
import "moment-timezone";
import React, { Component } from "react";
import history from "../history";
import LoadingInProgress from "../Shared/LoadingInProgress";
import SeminarsService from '../utils/SeminarsService';
import { timezones } from "../utils/variables";
import EditForm from './EditForm';

class Show extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.updateSeminar = this.updateSeminar.bind(this)
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    this.setState({ finishedLoading: false });
    SeminarsService.get(params.id).then(data => {
      data.at = moment(data.at).tz(timezones[data.region])
      this.setState({ finishedLoading: true, item: data })
    });
  }

  updateSeminar(values) {
    const { match: { params } } = this.props;
    SeminarsService.update(this.state.item.id, values).then(data => {
      this.setState({ finishedLoading: true, item: data }, () => history.push(`/m1/seminars/${params.id}`));
    });
  }

  render() {
    const { finishedLoading } = this.state;

    return (
      <div>
        {finishedLoading && this.state.item ? (
          <div>
            <div className="row">
              <div className="col-md-6 col-md-offset-3">
                <h1 className="first-title" style={{ marginBottom: '20px' }}>
                  {this.state.item.location} -
                  {moment(this.state.item.at).tz(timezones[this.state.item.region]).format("MMM Do YYYY hh:mm a")}
                </h1>

                <div className="well">
                  <EditForm
                    item={this.state.item}
                    updateSeminar={this.updateSeminar}
                  />
                </div>
              </div>
            </div>
            <div style={{ marginTop: '50px' }}><hr /><small className='pull-right'>Seminar #{this.state.item.id}</small></div>
          </div>
        ) : (
            <LoadingInProgress message="Loading" />
          )}
      </div>

    );
  }
}
export default Show;
